export default __webpack_public_path__ + "static/media/payload.26f60e92.svg";